import * as is from 'utilities/is';
import { RELOAD_TYPES } from 'constants';
import { getStateLogger } from 'utilities/state';
import { EXTERNAL_EVENT_MAP } from './event_maps';
import { PLAYER_CONTROL_EVENT, APPLICATION_EVENT } from 'constants/events';

export class PlayerApi {
    destroy() {
        return new Promise((resolve, reject) => {
            this.playerAdapter && this.playerAdapter.dispose();
            resolve();
        });
    }

    play() {
        this.eventBus.emit(PLAYER_CONTROL_EVENT.PLAY);
    }

    pause() {
        this.eventBus.emit(PLAYER_CONTROL_EVENT.PAUSE);
    }

    reload(type = RELOAD_TYPES.DATA, overrides) {
        switch(type) {
            case RELOAD_TYPES.DATA:
            case RELOAD_TYPES.OVERRIDES_ONLY:
                this.dataLoader.reload(overrides, type);
                break;
            default:
                this.initialize(this.options);
                break;
        }
    }

    getTrackId() {}
    resize(width, height) {}
    resetVariables() {}
    
    getData(name) {
        return this.getVariable(name);
    }
    
    setData(name, value = '') {
        this.setVariable(name, value);
    }

    setVariable(name, value = '') {
        this.eventBus.emit(APPLICATION_EVENT.SET_VARIABLES, { [name]: value });
    }

    getVariable(name) {
        const variables = (
            this.dataLoader &&
            this.dataLoader.stateEngine &&
            this.dataLoader.stateEngine.variables
        )

        return variables[name];
    }

    getStateOverrides() {
        return getStateLogger().toOverrides();
    }

    lockState(stateName, value) {
        this.eventBus.emit(APPLICATION_EVENT.LOCK_STATE, stateName, value);
    }

    unlockState(stateName) {
        this.eventBus.emit(APPLICATION_EVENT.UNLOCK_STATE, stateName);
    }

    set animate(shouldAnimate) {
        this.eventBus.emit(APPLICATION_EVENT.ANIMATE_CHANGE, shouldAnimate);
    }

    set language(language) {
        if (this.eventBus && language) {
            this.eventBus.emit(APPLICATION_EVENT.SET_STATE, 'language', language);
        }
    }

    get language() {
        return this.dataLoader?.stateEngine?.activeState?.language || this.playerAdapter?.language;
    }

    set level(level) {
        if (this.eventBus && is.defined(level)) {
            this.eventBus.emit(APPLICATION_EVENT.LEVEL_CHANGED, level);
        }
    }

    get level() {
        return this.dataLoader?.stateEngine?.activeState?.level || this.playerAdapter?.level;
    }

    get currentTime() {
        return this.playerAdapter && this.playerAdapter.currentTime || 0;
    }

    set currentTime(time) {
        if (this.eventBus) {
            const autoplay = false;
            this.eventBus.emit(PLAYER_CONTROL_EVENT.CURRENT_TIME, time, autoplay);
        }
    }

    /* Proxy eventBus so we can attach listeners once it's available */ 
    get eventBus() {
        return this._eventBus;
    }

    set eventBus(bus) {
        this._eventBus = bus;

        Object
            .keys(EXTERNAL_EVENT_MAP)
            .forEach(key => {
                if (this.options && is.fn(this.options[`on${key}`])) {
                    bus.on(EXTERNAL_EVENT_MAP[key], (...args) => this.options[`on${key}`](...args))
                }
            });
    }

    get paused() {
        return this.playerAdapter && this.playerAdapter.paused;
    }

    get duration() {
        return this.playerAdapter && this.playerAdapter.duration;
    }

    get volume() {
        return this.playerAdapter && this.playerAdapter.volume;
    }

    set volume(vol) {
        if (this.playerAdapter) {
            this.playerAdapter.volume = vol;
        }
    }
}